import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import downloadButton from '../../assets/images/download-button.svg'
import closeButton from '../../assets/images/close-button.svg'
import "./style.scss";
let FileSaver = require('file-saver');

function AttatchmentModal(props) {
  const [show, setShow] = useState(!!props.show);
  const handleClose = () => {
    setShow(false);
    props.closeCallback();
  };

  const handleCrossClose = () => {
    setShow(false);
    props.crossCloseCallback();
  }

  /* Helper function */
  const downloadFile = (fileURL, fileName) => {
    FileSaver.saveAs(fileURL, fileName);
  }

  useEffect(() => {
    const ifr = document.getElementById('forecast_embed');
    if (ifr) {
      let interval = setInterval(() => {
        ifr.src = "https://docs.google.com/gview?url=" +
          props.attatchment +
          "&embedded=true"
      }, 2000);

      const handleLoad = () => {
        console.log('load the iframe')
        clearInterval(interval)
      }
      
      ifr.onload = handleLoad;
      
      return () => {
        clearInterval(interval);
        ifr.onload = null;
      };
    }
  }, [props.attatchment])




  return (
    <>
      <Modal size="lg" centered className="special-attachment-modal" show={show} onHide={()=>handleClose()}>
        <ModalBody>
          <div className="row">
            <div className="col-12 py-1 background-white">
              <div className="bread-crumb d-flex align-items-center justify-content-between">
                <span className="color-gray mt-2 font-14 ml-2">
                  {props.breadCrumb}
                </span>

                <div>
                  <button
                    onClick={handleCrossClose}
                    type="button"
                    className="close mr-3"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <img src={closeButton} alt="Close" />
                  </button>

                  {!!!props.isVideo && !!!props.isImage && (
                    <button
                        onClick={() => { downloadFile(props.attatchment, "attatchment.pdf") }}
                        type="button"
                        className="close download mr-4"
                        aria-label="Download PDF"
                      >
                        <img src={downloadButton} alt="Download" />
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-12">
              {!!props.isVideo && (<>
                <iframe 
                  width="100%" 
                  className="border-none" 
                  height="500"
                  src={props.attatchment}
                  title="Video content"
                >
                </iframe></>
              )}
              {!!!props.isVideo && !!!props.isImage && (
                <div>
                <iframe
                id="forecast_embed"
                  className="doc iframe"
                  frameBorder="0"
                  title="Document viewer"
                  src={
                    "https://docs.google.com/gview?url=" +
                    props.attatchment +
                    "&embedded=true"
                  }
                ></iframe>
                </div>
              )}
              {!!!props.isVideo && !!props.isImage && (
                  <img src={props.attatchment} style={{width:"100%"}} alt="Attachment" />
              )}

            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default AttatchmentModal;
